
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.41 1a1.935 1.935 0 011.84 1.852V7.5h-1V2.977a.938.938 0 00-.76-.965L14.386 2H2.138a.938.938 0 00-.887.886L1.25 21.023c-.021.478.32.889.76.965l.104.012h12.248a.939.939 0 00.888-.886L15.25 21v-4.5h1v4.477a1.939 1.939 0 01-1.71 2.01l-.154.013H2.088a1.934 1.934 0 01-1.839-1.852L.251 3.023a1.938 1.938 0 011.708-2.01L2.113 1h12.298zm5.444 6.9l4.103 4.104-4.103 4.104-.708-.708 2.896-2.897-14.542.001v-1l14.542-.001-2.896-2.895.708-.708z","fill":"#373534","fill-rule":"evenodd"}})])
          )
        }
      }
    